import { useRef, useEffect } from 'react';
import './SiteUnitCommandsPopup.scoped.scss';
import Button from '@components/_elements/Button/Button';
import storeConnector from '@store/storeConnector';
import useAlias from '@src/hooks/useAlias';

const DEFAULT_DEVICE_TYPE = 'DCDC';

const ConverterCommandsTable = ({
  getConvertedIdxStr,
  setOverInput,
  setConvertersRealArr,
  showConfPopup,
  siteMeta,
  convertersRealArr,
  converterIdxStr,
}) => {
  const alias = useAlias();
  const initialValuesRef = useRef(null);

  // Store initial values when component mounts or convertersRealArr changes from external source
  useEffect(() => {
    if (initialValuesRef.current === null) {
      initialValuesRef.current = [...convertersRealArr];
    }
  }, [convertersRealArr]);

  const handleSend = (index) => {
    // Get the device type from siteMeta
    const deviceType =
      siteMeta?.Converter_Commands?.[0]?.Device || DEFAULT_DEVICE_TYPE;
    // Set the full converter ID (e.g., "DCDC01")
    converterIdxStr.current = `${deviceType}${getConvertedIdxStr(index)}`;
    showConfPopup(`Power::${convertersRealArr[index]}`, 'value');
    // Update initial value to current value after sending
    if (initialValuesRef.current) {
      initialValuesRef.current[index] = convertersRealArr[index];
    }
  };

  return (
    <>
      <div className='bold vertical-margin'>
        {alias('Converter Power Commands')}
      </div>
      <table className='converter-commands-table'>
        <tbody>
          {Array(+siteMeta.NumConverters)
            .fill()
            .map((_, i) => (
              <tr key={`converter row ${i}`}>
                <td className='bold'>{getConvertedIdxStr(i)}</td>
                <td>
                  P:{' '}
                  <input
                    className='comand-popup-inp width-50 horizontal-margin'
                    type='number'
                    step='0.1'
                    value={convertersRealArr[i]}
                    onMouseEnter={() => setOverInput(true)}
                    onMouseLeave={() => setOverInput(false)}
                    onChange={(e) => {
                      const value = e.target.value;
                      setConvertersRealArr((prev) => {
                        const arr = [...prev];
                        arr[i] = value;
                        return arr;
                      });
                    }}
                  />{' '}
                  kW
                </td>
                <td>
                  <Button
                    size='m'
                    onClick={() => handleSend(i)}
                    disabled={
                      convertersRealArr[i] === '' ||
                      (initialValuesRef.current !== null &&
                        Number(convertersRealArr[i]) ===
                          Number(initialValuesRef.current[i]))
                    }
                  >
                    {alias('Send')}
                  </Button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default storeConnector(ConverterCommandsTable, {
  config: ['siteMeta'],
});
